import clsx from 'clsx';

function Skeleton({
  className,
  animate = true,
}: React.HTMLAttributes<HTMLDivElement> & { animate?: boolean }) {
  return (
    <div
      className={clsx(
        animate && 'animate-skeleton',
        'overflow-hidden rounded-lg bg-neutral-500',
        className,
      )}
    ></div>
  );
}

export default Skeleton;
